<template>
	<div class="screen home">
		<div class="home-content">
			<div class="logo">{{ l.home_logo }}</div>
			<p class="home-sub-title">{{ l.home_drop_volunteer }}</p>
				
			<div class="home-drops">
				<div class="home-drop" v-droppable></div>
			</div>

			<div ref="heroes" class="heroes">
				<div
					v-for="hero in app.account.collection.heroes"
					:key="hero.slug"
					:data-slug="hero.slug"
					class="home-hero-wrap"
					:class="{ unlocked: hero.locked == false }"
					@mouseenter="hover_hero = hero"
					@mouseleave="hover_hero = false"
				>
					<hero :hero="hero" />
					<div class="unlock-button" @click="unlock_hero(hero)">
						<span class="lock">{{ l.home_unlock }}</span>
						<span class="price">{{ hero.cost }}<span class="icon"></span></span>
					</div>
				</div>
			</div>

			<div class="hero-description">
				<span v-if="hover_hero">{{ hover_hero[lang].description }}</span>
			</div>

		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Bus from '@/libs/bus'
import interact from 'interactjs'
import data_items from '@/data/cards/item.json'
import data_heroes from '@/data/heroes.json'
import Hero from '@/components/game/hero'

export default {
	name: 'home',
	data: function() {
		return {
			hover_hero: false,
			dragging_hero: false
		}
	},
	computed: Object.assign(mapGetters([ 'l', 'lang', 'app' ]), {
		
	}),
	methods: {
		set_screen: function(screen) {
			this.$store.dispatch('set_screen', { screen: screen })
		},
		unlock_hero: function(hero) {
			if (hero.cost <= this.app.account.gold) {
				this.$store.dispatch('unlock_hero', { hero: hero })
			}
		},
		new_game: function(hero_slug) {
			var self = this
			var hero = _.find(this.app.account.collection.heroes, { slug: hero_slug })
			// this.$store.dispatch('set_screen', { screen: '' })
			// setTimeout(function() {
				self.$store.dispatch('set_screen', { screen: 'game' })
				self.$store.dispatch('init_game', { hero: hero })
			// }, 500)
		}
	},
	directives: {
		droppable: {
			inserted: function(el, binding, vnode) {
				var self = vnode.context
				interact(el).dropzone({
					accept: '.hero',
					overlap: 0.3,
					ondragenter: function (event) {
						event.target.classList.add('dropping')
					},
					ondragleave: function (event) {
						event.target.classList.remove('dropping')
					},
					ondrop: function (event) {
						event.target.classList.remove('dropping')

						var hero_slug = event.relatedTarget.parentNode.getAttribute('data-slug')
						var position = -1
						_.each(self.$refs.heroes.children, function(e) {
							position++
							if (e.getAttribute('data-slug') == hero_slug) return false
						})

						if (position > -1) {
							var x = 0
							var y = -(event.relatedTarget.offsetHeight + 24 + 0 + 16)
							if (position == 0)  x = event.relatedTarget.offsetWidth + (event.relatedTarget.offsetWidth / 2) + (16 + 8)
							if (position == 1)  x = (event.relatedTarget.offsetWidth / 2) + (8)
							if (position == 2)  x = -((event.relatedTarget.offsetWidth / 2) + (8))
							if (position == 3) x = -(event.relatedTarget.offsetWidth + (event.relatedTarget.offsetWidth / 2) + (16 + 8))
							event.relatedTarget.style.webkitTransform = event.relatedTarget.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1)'
						}
						// Sounds.play('drop')
						setTimeout(function() {
							self.new_game(hero_slug)
						}, 500)
					}
				});
			}
		}
	},
	mounted: function() {
		var self = this
		Bus.$on('new-game', function(data) {
			self.new_game(data.hero_slug)
		})
	},
	components: { Hero }
}
</script>
<style lang="stylus">
@import '../assets/css/app'


.home
	.home-content
		position absolute
		left 50%
		top 50%
		transform translate(-50%, -50%)
		width ((card_width + 16px) * 4)
		.logo
			margin 0 0 4px 0
			font-size 3.2rem
			text-align center
			line-height 32px
		.home-sub-title
			margin 0 0 24px 0
			font-size 1.6rem
			line-height 24px
			text-align center
		.home-drops
			display block
			margin 0 0 24px 0
			.home-drop
				margin 0 auto
				width (card_width + 16px)
				height (card_height + 16px)
				background darken(dark, 10%)
				border-radius 6px
				&.dropping
					background-color darken(dark, 25%)
				&:before
					content ''
					position absolute
					left 0
					top 0
					right 0
					bottom 0
					background url(../assets/img/ui/card-back.png) center center no-repeat
					background-size 64px auto
					opacity 0.05
				&:after
					content ''
					position absolute
					left 0
					top 0
					right 0
					bottom 0
					background url(../assets/img/ui/card-bg-deco-no-value.png) center center no-repeat
					background-size 100% 100%
					transform scale(1)
					animation home_drop_frame 1.5s alternate easeOutQuart infinite 
		.heroes
			display flex
			align-items center
			justify-content center
			flex-wrap wrap
			.home-hero-wrap
				display inline-block
				width card_width
				height card_height
				margin 8px
				&.unlocked
					.hero
						opacity 1
					.unlock-button
						display none
				.hero
					position absolute
					left 0
					top 0
					opacity 0.25
				.unlock-button
					position absolute
					left -8px
					top -8px
					right -8px
					bottom -8px
					display flex
					flex-direction column
					justify-content center
					align-items center
					align-content center
					z-index 3
					cursor pointer 1
					background-color alpha(dark, 75%)
					text-align center
					font-size 2.4rem
					line-height 24px
					span
						margin 4px 0
						> .icon
							display inline-block
							width 16px
							height 16px
							margin 0 0 0 4px
							background url(../assets/img/ui/icons.png) 0 0 no-repeat
							background-position (-16px * 3) 0
							background-size auto 32px
		.hero-description
			padding 16px
			height (32px + 40px)
			line-height 20px


@keyframes home_drop_frame
	100%
		transform scale(0.9)


@media screen and (max-width: 570px)
	.home .home-content
		width 100%
		
@media screen and (max-width: 420px)
	.home .home-content
		transform translate(-50%, -50%) scale(0.9)
		
@media screen and (max-width: 375px)
	.home .home-content
		transform translate(-50%, -50%) scale(0.8)
		
@media screen and (max-width: 330px)
	.home .home-content
		transform translate(-50%, -50%) scale(0.75)
	
</style>
